export default __webpack_public_path__ + "static/media/0095.6dd1e400.jpg";